import script from "./DropDownOption.vue?vue&type=script&setup=true&lang=js"
export * from "./DropDownOption.vue?vue&type=script&setup=true&lang=js"

import "./DropDownOption.vue?vue&type=style&index=0&id=523e4756&lang=css"

const __exports__ = script;

export default __exports__